export default class MoveSet {
    config() {
        return {
            title: 'Move set',
            description: 'Choose an existing gallery to move the selected galleries to.',
            mode: 'single',
            sets: true,
            media: false,
            tree: true,
            upload: {
                allow: false,
            },
            defaultFilters: [],
            filterOptions: [],
        };
    }
    doAction() {
        console.log('UploadNewVersion::doAction()');
        const id = App.$store.getters.getMediaSelectSelected.pop();
        const setsToMove = App.$store.getters.getMediaSetSelectedIds;
        const options = App.$store.getters.getMediaSelectOptions;

        return new Promise((resolve) => {
            const promises = [];

            if (id) {
                // update sets children
                promises.push(
                    App.$store.dispatch('updateSet', {
                        id,
                        data: {
                            children: setsToMove,
                        },
                    })
                );
            } else {
                // has no set is root gallery
                setsToMove.forEach((setId) => {
                    promises.push(App.$store.dispatch('removeSetParent', setId));
                });
            }

            Promise.all(promises).then(() => {
                console.log('itemId', options.itemId);
                App.$store.dispatch('fetchMediaSet', options.itemId).then((response) => resolve(response));
            });
        });
    }
}
